import React, { FC, useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useField } from 'formik';
import { FieldLabel } from '../../fields/FieldLabel/FieldLabel';
import { useUser } from '../../../hooks/useUser';
import { isInternal, isRMN } from '../../../utils';
import InlineBrandSelector from '../../../pages/videoProduction/components/InlineBrandSelector';
import { FieldError } from '../../fields/FieldError/FieldError';

interface Props {
  setFieldValue: (name: string, value: any) => void;
}

export const BrandSelector: FC<Props> = ({ setFieldValue }) => {
  const { role, user } = useUser();
  const [, brandName, { setValue: setBrandName }] = useField({
    name: 'brand_name',
  });
  const [, brandId, { setValue: setBrandId }] = useField({
    name: 'brand_id',
  });
  const [selectedBrand, setSelectedBrand] = useState<any>(null);

  useEffect(() => {
    setSelectedBrand((prev: any) =>
      brandName.value ? { ...prev, name: brandName.value } : null
    );
  }, [brandName.value]);

  useEffect(() => {
    setBrandId(selectedBrand?.id);
  }, [selectedBrand?.id]);

  return (
    <Stack>
      <FieldLabel required>Select Brand</FieldLabel>
      <InlineBrandSelector
        isRMN={false}
        disabled={false}
        filterRmn={false}
        allowAdd={isInternal(role) || isRMN(user)}
        setFieldValue={setFieldValue}
        showRmnToggle={isInternal(role)}
        selectedBrand={selectedBrand}
        setSelectedBrand={(brd: any) => {
          setSelectedBrand(brd);
          setBrandName(brd?.name);
        }}
      />

      {brandName.error && brandName.touched && (
        <FieldError>{brandName.error}</FieldError>
      )}
    </Stack>
  );
};
